import { Tooltip } from "@mui/material";
import { Edit, Trash, PlusCircle } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useEffect, useState } from "react";
import ReactDragListView from "react-drag-listview";
import API from "../../API/newIndex";
import MetaFieldForm from "../../controllers/MetaFieldForm";
import NoRecords from "../Main/NoRecords";
import Notification from "../Notification";
import { ButtonComponent, CommonTable, ConfirmationPopup } from "@shopeasy-dashboard-ui/ui-library";

const GetManufactureMetaField = () => {
  const [manufactureData, setManufactureData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openMetaFieldForm, setOpenMetaFieldForm] = useState(false);
  const [editData, setEditData] = useState({});
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [metaFieldId, setMetaFieldId] = useState(null);

  const handleCloseNotification = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  const getManufactureMetaField = async (showSkeleton = false) => {
    if (showSkeleton || manufactureData.length === 0) {
      setLoading(true);
    }
    try {
      const ApiCall = await API({
        url: "admin/metafieldgroup/getMetaFieldGroup/manufacture",
        method: "get",
      });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        const result = ApiCall?.data;
        setManufactureData(result?.data?.custom_fields);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getManufactureMetaField(true);
  }, []);

  const sortProduct = async (index, id) => {
    try {
      const payload = {
        newIndex: index === 0 ? 0 : index,
      };
      await API({
        url: `/admin/metafieldgroup/UpdateMetaField/${id}`,
        method: "put",
        data: payload,
      });
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  // const HandleSort = (result) => {
  //   const items = Array.from(manufactureData);
  //   const [reorderedItem] = items.splice(result?.source?.index, 1);
  //   items.splice(result?.destination?.index, 0, reorderedItem);
  //   setManufactureData(items);
  // };

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      if (fromIndex === toIndex) return;
      const newItems = [...manufactureData];
      const [movedItem] = newItems.splice(fromIndex, 1);
      newItems.splice(toIndex, 0, movedItem);
      setManufactureData(newItems);
      sortProduct(toIndex, movedItem?._id || metaFieldId);
      setMetaFieldId(null);
    },
    nodeSelector: "tr",
    handleSelector: ".drag-handle",
  };

  const handleEdit = (elem) => {
    setOpenMetaFieldForm(true);
    setEditData(elem);
  };

  const handleCloseConfirm = (value) => {
    setConfirmationPopup(value);
  };

  const removeManufactureMetaField = async () => {
    try {
      const ApiCall = await API({
        url: `admin/metafieldgroup/DeleteMetaFieldGroup/${deleteId}`,
        method: "delete",
      });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        setIsNotification(true);
        setNotificationMsg("Meta field deleted successfully");
        setSeverity("success");
        setConfirmationPopup(false);
        setDeleteId("");
        getManufactureMetaField();
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
      setConfirmationPopup(false);
    }
  };

  const handleCloseMetaFieldForm = () => {
    setOpenMetaFieldForm(false);
    setEditData({});
  };

  const columns = [
    {
      title: "",
      key: "drag",
      align: "text-center",
      className: "w-[40px] min-w-[40px] max-w-[40px]",
      ignoreRowClick: true,
      render: () => (
        <div className="flex items-center justify-center">
          <span className="drag-handle cursor-grab active:cursor-grabbing p-1 rounded text-gray-400 hover:text-gray-600 transition-colors inline-flex items-center justify-center">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="cursor-grab active:cursor-grabbing"
            >
              <circle cx="5" cy="3" r="1.5" fill="currentColor" />
              <circle cx="11" cy="3" r="1.5" fill="currentColor" />
              <circle cx="5" cy="8" r="1.5" fill="currentColor" />
              <circle cx="11" cy="8" r="1.5" fill="currentColor" />
              <circle cx="5" cy="13" r="1.5" fill="currentColor" />
              <circle cx="11" cy="13" r="1.5" fill="currentColor" />
            </svg>
          </span>
        </div>
      ),
    },
    {
      title: t("lang_group_name"),
      key: "custom_field_name",
      className: "w-full",
      render: (row) => <span className="line-clamp-2">{row.custom_field_name || "-"}</span>,
    },
    {
      title: t("lang_Content_type"),
      key: "custom_field_type",
      className: "w-full",
      render: (row) => <span>{row.custom_field_type || "-"}</span>,
    },
    {
      title: t("lang_action"),
      key: "action",
      align: "text-right",
      className: "min-w-[80px] max-w-[80px] sm:min-w-[120px] sm:max-w-[120px]",
      ignoreRowClick: true,
      render: (row) => (
        <div className="w-full space-x-2 text-right">
          <Tooltip title="Edit" arrow>
            <button
              type="button"
              className="text-black-500 hover:text-black-600"
              onClick={() => handleEdit(row)}
            >
              <Edit className="w-[17px] h-[17px]" />
            </button>
          </Tooltip>
          <Tooltip title="Delete" arrow>
            <button
              type="button"
              className="text-red-500 hover:text-red-600"
              onClick={() => {
                setConfirmationPopup(true);
                setDeleteId(row?._id);
              }}
            >
              <Trash className="w-[17px] h-[17px]" />
            </button>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div className="w-full">
      {isNotification && notificationMsg && (
        <Notification
          message={notificationMsg}
          close={handleCloseNotification}
          severity={severity}
        />
      )}
      <div className="flex flex-wrap items-center justify-between w-full pb-4">
        <div className="flex items-center space-x-2">
          <h5>{t("lang_Manufactures")}</h5>
        </div>
        <ButtonComponent
          variant="primary"
          icon={<PlusCircle size={16} className="mr-1.5" />}
          onClick={() => setOpenMetaFieldForm(true)}
        >
          {t("lang_add_manufacture")}
        </ButtonComponent>
      </div>

      <ReactDragListView {...dragProps}>
        <CommonTable
          columns={columns}
          data={manufactureData}
          loading={loading}
          skeletonRows={5}
          rowClick={(row) => handleEdit(row)}
          rowProps={(row) => ({
            onDragStart: () => setMetaFieldId(row?._id),
          })}
          emptyMessage={<NoRecords />}
        />
      </ReactDragListView>

      {openMetaFieldForm && (
        <MetaFieldForm
          openMetaFieldForm={openMetaFieldForm}
          handleClose={handleCloseMetaFieldForm}
          heading="Manufacture"
          editData={editData}
          onSuccess={getManufactureMetaField}
        />
      )}
      {confirmationPopup && (
        <ConfirmationPopup
          heading="Delete manufacture meta-field"
          subheading="Do you really want to delete this manufacture meta-field from your store?"
          confirmationPopup={confirmationPopup}
          handleCloseConfirm={handleCloseConfirm}
          runFunction={removeManufactureMetaField}
        />
      )}
    </div>
  );
};

export default GetManufactureMetaField;
